import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSlider, MatSliderThumb } from '@angular/material/slider';

@Component({
  selector: 'dmb-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  imports: [MatSlider, MatSliderThumb, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SliderComponent {
  readonly name = input('');
  readonly standalone = input(true);
  readonly type = input('range');
  readonly min = input(0);
  readonly max = input(10);
  readonly showTickmarks = input(true);
  readonly value = input(0);

  readonly slideEvent = output<string>();

  change(value: string) {
    this.slideEvent.emit(value);
  }
}
